import { useNavigate } from "react-router-dom";
import { BottomNav } from "@/components/shared/Navigation";
import { ArrowLeft } from "lucide-react";
import TruckLeaderboard from "@/components/trucks/TruckLeaderboard";

export default function TruckLeaderboardPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 pb-24" data-testid="truck-leaderboard-page">
      <header className="sticky top-0 z-40 bg-white border-b border-slate-100 px-4 py-3 flex items-center gap-3">
        <button onClick={() => navigate(-1)} className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center" data-testid="lb-back">
          <ArrowLeft className="w-4 h-4 text-slate-600" />
        </button>
        <h1 className="text-sm font-bold text-slate-800">Food Truck Leaderboard</h1>
      </header>
      <div className="px-4 py-4">
        <TruckLeaderboard />
      </div>
      <BottomNav />
    </div>
  );
}
